/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v12.3.1.0 (NJsonSchema v9.14.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { AbpServiceBase } from '../abp-service-base';

export class FirmwareServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 添加固件发行日志
     * @param action 动作[0发行/1上报。其他的请按往后顺延]
     * @param actionState 动作状态
     * @param actionTime 时间戳
     * @param gatewayToken 网关token
     * @param issueId 发行ID
     * @param message 消息内容
     * @param sign 签名
     * @return OK
     */
    createFirmwareLog(action: number, actionState: number, actionTime: string, gatewayToken: string, issueId: string, message: string, sign: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-console')+ "/firmware-log/add?";
        if (action === undefined || action === null)
            throw new Error("The parameter 'action' must be defined and cannot be null.");
        else
            url_ += "action=" + encodeURIComponent("" + action) + "&"; 
        if (actionState === undefined || actionState === null)
            throw new Error("The parameter 'actionState' must be defined and cannot be null.");
        else
            url_ += "actionState=" + encodeURIComponent("" + actionState) + "&"; 
        if (actionTime === undefined || actionTime === null)
            throw new Error("The parameter 'actionTime' must be defined and cannot be null.");
        else
            url_ += "actionTime=" + encodeURIComponent("" + actionTime) + "&"; 
        if (gatewayToken === undefined || gatewayToken === null)
            throw new Error("The parameter 'gatewayToken' must be defined and cannot be null.");
        else
            url_ += "gatewayToken=" + encodeURIComponent("" + gatewayToken) + "&"; 
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        if (message === undefined || message === null)
            throw new Error("The parameter 'message' must be defined and cannot be null.");
        else
            url_ += "message=" + encodeURIComponent("" + message) + "&"; 
        if (sign === undefined || sign === null)
            throw new Error("The parameter 'sign' must be defined and cannot be null.");
        else
            url_ += "sign=" + encodeURIComponent("" + sign) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateFirmwareLog(_response);
        });
    }

    protected processCreateFirmwareLog(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 删除固件集
     * @param ids 删除固件Id数组
     * @return OK
     */
    deleteFirmwares(ids: number[]): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-console')+ "/firmwares?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteFirmwares(_response);
        });
    }

    protected processDeleteFirmwares(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 下载固件
     * @param issueId 固件发行ID
     * @param sign 签名
     * @return OK
     */
    downloadFirmware(issueId: string, sign: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-console')+ "/firmwares-download/{issueId}/{sign}";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined.");
        url_ = url_.replace("{issueId}", encodeURIComponent("" + issueId)); 
        if (sign === undefined || sign === null)
            throw new Error("The parameter 'sign' must be defined.");
        url_ = url_.replace("{sign}", encodeURIComponent("" + sign)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDownloadFirmware(_response);
        });
    }

    protected processDownloadFirmware(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 发行固件
     * @param dto 发行固件信息
     * @return OK
     */
    issueFirmware(dto: IssueFirmwareDto): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-console')+ "/firmwares/issue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processIssueFirmware(_response);
        });
    }

    protected processIssueFirmware(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 查询固件集
     * @param current (optional) 当前页
     * @param fileName (optional) 固件名称
     * @param size (optional) 每页的数量
     * @param tenantId (optional) 租户Id
     * @param version (optional) 版本
     * @return OK
     */
    getFirmwares(current: number | null | undefined, fileName: string | null | undefined, size: number | null | undefined, tenantId: string | null | undefined, version: string | null | undefined): Promise<PagingOf固件信息> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-console')+ "/firmwares/list?";
        if (fileName !== undefined)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (version !== undefined)
            url_ += "version=" + encodeURIComponent("" + version) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetFirmwares(_response);
        });
    }

    protected processGetFirmwares(response: AxiosResponse): Promise<PagingOf固件信息> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PagingOf固件信息.fromJS(resultData200) : new PagingOf固件信息();
            return result200;
        }
        return Promise.resolve<PagingOf固件信息>(<any>null);
    }

    /**
     * 查询日志
     * @param issueId 发行Id
     * @return OK
     */
    getFirmwareLogs(issueId: string): Promise<固件日志信息_1[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-console')+ "/firmwares/logs?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetFirmwareLogs(_response);
        });
    }

    protected processGetFirmwareLogs(response: AxiosResponse): Promise<固件日志信息_1[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(固件日志信息_1.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<固件日志信息_1[]>(<any>null);
    }

    /**
     * 分页查询日志
     * @param dto 固件日志信息
     * @return OK
     */
    getPageFirmwareLogs(dto: QueryFirmwareLogDto): Promise<PagingOf固件日志信息> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-console')+ "/firmwares/logs/page";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageFirmwareLogs(_response);
        });
    }

    protected processGetPageFirmwareLogs(response: AxiosResponse): Promise<PagingOf固件日志信息> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PagingOf固件日志信息.fromJS(resultData200) : new PagingOf固件日志信息();
            return result200;
        }
        return Promise.resolve<PagingOf固件日志信息>(<any>null);
    }

    /**
     * 更新固件
     * @param fileInfoDto 固件包信息
     * @param id 固件ID
     * @return OK
     */
    updateFirmware(fileInfoDto: FileInfoDto, id: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-console')+ "/firmwares/update/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fileInfoDto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateFirmware(_response);
        });
    }

    protected processUpdateFirmware(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 上传固件
     * @param fileInfoDto 固件包信息
     * @return OK
     */
    uploadFirmware(fileInfoDto: FileInfoDto): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-console')+ "/firmwares/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fileInfoDto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUploadFirmware(_response);
        });
    }

    protected processUploadFirmware(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 查询固件信息
     * @param id 固件ID
     * @return OK
     */
    getFirmware(id: string): Promise<固件信息> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-console')+ "/firmwares/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetFirmware(_response);
        });
    }

    protected processGetFirmware(response: AxiosResponse): Promise<固件信息> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? 固件信息.fromJS(resultData200) : new 固件信息();
            return result200;
        }
        return Promise.resolve<固件信息>(<any>null);
    }

    /**
     * 删除固件
     * @param id 删除固件Id
     * @return OK
     */
    deleteFirmware(id: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-console')+ "/firmwares/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteFirmware(_response);
        });
    }

    protected processDeleteFirmware(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class ConsoleGatewayServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 登记网关
     * @param activateCount 激活总数
     * @param batchNo 批次号
     * @param name (optional) 备注[别名]
     * @return OK
     */
    add(activateCount: number, batchNo: string, name: string | null | undefined): Promise<string[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-console')+ "/gatewaies?";
        if (activateCount === undefined || activateCount === null)
            throw new Error("The parameter 'activateCount' must be defined and cannot be null.");
        else
            url_ += "activateCount=" + encodeURIComponent("" + activateCount) + "&"; 
        if (batchNo === undefined || batchNo === null)
            throw new Error("The parameter 'batchNo' must be defined and cannot be null.");
        else
            url_ += "batchNo=" + encodeURIComponent("" + batchNo) + "&"; 
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        }
        return Promise.resolve<string[]>(<any>null);
    }

    /**
     * 修改网关
     * @param gatewayId 网关主键
     * @param name 名称
     * @return OK
     */
    update(gatewayId: string, name: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-console')+ "/gatewaies?";
        if (gatewayId === undefined || gatewayId === null)
            throw new Error("The parameter 'gatewayId' must be defined and cannot be null.");
        else
            url_ += "gatewayId=" + encodeURIComponent("" + gatewayId) + "&"; 
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined and cannot be null.");
        else
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 回收网关
     * @param ids (optional) 删除网关的ID
     * @return OK
     */
    discard(ids: string[] | null | undefined): Promise<{ [key: string] : string; }> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-console')+ "/gatewaies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDiscard(_response);
        });
    }

    protected processDiscard(response: AxiosResponse): Promise<{ [key: string] : string; }> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200![key] = resultData200[key];
                }
            }
            return result200;
        }
        return Promise.resolve<{ [key: string] : string; }>(<any>null);
    }

    /**
     * 查询授权信息
     * @param code 二维码密文
     * @return OK
     */
    getAuthorization(code: string): Promise<AuthorInfoVo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-console')+ "/gatewaies/authorizations?";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined and cannot be null.");
        else
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAuthorization(_response);
        });
    }

    protected processGetAuthorization(response: AxiosResponse): Promise<AuthorInfoVo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? AuthorInfoVo.fromJS(resultData200) : new AuthorInfoVo();
            return result200;
        }
        return Promise.resolve<AuthorInfoVo>(<any>null);
    }

    /**
     * 分页查询
     * @param current (optional) 当前页
     * @param isDeleted (optional) 是否有效[1=删除，0=未删除]
     * @param searchKey (optional) 检索关键字
     * @param size (optional) 每页的数量
     * @param tenantId (optional) 检索关键字[租户id]
     * @return OK
     */
    queryGatewayList(current: number | null | undefined, isDeleted: boolean | null | undefined, searchKey: string | null | undefined, size: number | null | undefined, tenantId: string | null | undefined): Promise<PageOfGatewayVo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-console')+ "/gatewaies/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (isDeleted !== undefined)
            url_ += "isDeleted=" + encodeURIComponent("" + isDeleted) + "&"; 
        if (searchKey !== undefined)
            url_ += "searchKey=" + encodeURIComponent("" + searchKey) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQueryGatewayList(_response);
        });
    }

    protected processQueryGatewayList(response: AxiosResponse): Promise<PageOfGatewayVo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PageOfGatewayVo.fromJS(resultData200) : new PageOfGatewayVo();
            return result200;
        }
        return Promise.resolve<PageOfGatewayVo>(<any>null);
    }

    /**
     * 查新明细
     * @param gatewayId 网关ID
     * @return OK
     */
    gatewayDetail(gatewayId: string): Promise<GatewayVo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-console')+ "/gatewaies/{gatewayId}";
        if (gatewayId === undefined || gatewayId === null)
            throw new Error("The parameter 'gatewayId' must be defined.");
        url_ = url_.replace("{gatewayId}", encodeURIComponent("" + gatewayId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGatewayDetail(_response);
        });
    }

    protected processGatewayDetail(response: AxiosResponse): Promise<GatewayVo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? GatewayVo.fromJS(resultData200) : new GatewayVo();
            return result200;
        }
        return Promise.resolve<GatewayVo>(<any>null);
    }

    /**
     * 导出授权信息
     * @param gatewayId 网关ID
     * @return OK
     */
    exportAuthorization(gatewayId: string): Promise<AuthorizationVo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-console')+ "/gatewaies/{gatewayId}/authorizations/export";
        if (gatewayId === undefined || gatewayId === null)
            throw new Error("The parameter 'gatewayId' must be defined.");
        url_ = url_.replace("{gatewayId}", encodeURIComponent("" + gatewayId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportAuthorization(_response);
        });
    }

    protected processExportAuthorization(response: AxiosResponse): Promise<AuthorizationVo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? AuthorizationVo.fromJS(resultData200) : new AuthorizationVo();
            return result200;
        }
        return Promise.resolve<AuthorizationVo>(<any>null);
    }
}

export class IothubServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 查询IOTHUB
     * @return OK
     */
    query(): Promise<IothubVo[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-console')+ "/iothubs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<IothubVo[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IothubVo.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<IothubVo[]>(<any>null);
    }
}

export class ProductRegisterServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 创建批次
     * @param allowConnections (optional) 网关最大授权数
     * @param iothubId (optional) IOT地址
     * @param productCode (optional) 产品代码
     * @param productName (optional) 产品名称
     * @param productType (optional) 产品类型
     * @param remark (optional) 备注
     * @param tenantId (optional) 租户
     * @param totalNumber (optional) 生产批次生产总量
     * @return OK
     */
    add(allowConnections: number | null | undefined, iothubId: string | null | undefined, productCode: string | null | undefined, productName: string | null | undefined, productType: number | null | undefined, remark: string | null | undefined, tenantId: string | null | undefined, totalNumber: number | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-console')+ "/product-registers?";
        if (allowConnections !== undefined)
            url_ += "allowConnections=" + encodeURIComponent("" + allowConnections) + "&"; 
        if (iothubId !== undefined)
            url_ += "iothubId=" + encodeURIComponent("" + iothubId) + "&"; 
        if (productCode !== undefined)
            url_ += "productCode=" + encodeURIComponent("" + productCode) + "&"; 
        if (productName !== undefined)
            url_ += "productName=" + encodeURIComponent("" + productName) + "&"; 
        if (productType !== undefined)
            url_ += "productType=" + encodeURIComponent("" + productType) + "&"; 
        if (remark !== undefined)
            url_ += "remark=" + encodeURIComponent("" + remark) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (totalNumber !== undefined)
            url_ += "totalNumber=" + encodeURIComponent("" + totalNumber) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 修改批次
     * @param allowConnections (optional) 网关最大授权数
     * @param batchNo 批次号
     * @param iothubId (optional) IOT地址
     * @param productCode (optional) 产品代码
     * @param productName (optional) 产品名称
     * @param productType (optional) 产品类型
     * @param remark (optional) 备注
     * @param tenantId (optional) 租户
     * @param totalNumber (optional) 生产批次生产总量
     * @return OK
     */
    update(allowConnections: number | null | undefined, batchNo: string, iothubId: string | null | undefined, productCode: string | null | undefined, productName: string | null | undefined, productType: number | null | undefined, remark: string | null | undefined, tenantId: string | null | undefined, totalNumber: number | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-console')+ "/product-registers?";
        if (allowConnections !== undefined)
            url_ += "allowConnections=" + encodeURIComponent("" + allowConnections) + "&"; 
        if (batchNo === undefined || batchNo === null)
            throw new Error("The parameter 'batchNo' must be defined and cannot be null.");
        else
            url_ += "batchNo=" + encodeURIComponent("" + batchNo) + "&"; 
        if (iothubId !== undefined)
            url_ += "iothubId=" + encodeURIComponent("" + iothubId) + "&"; 
        if (productCode !== undefined)
            url_ += "productCode=" + encodeURIComponent("" + productCode) + "&"; 
        if (productName !== undefined)
            url_ += "productName=" + encodeURIComponent("" + productName) + "&"; 
        if (productType !== undefined)
            url_ += "productType=" + encodeURIComponent("" + productType) + "&"; 
        if (remark !== undefined)
            url_ += "remark=" + encodeURIComponent("" + remark) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (totalNumber !== undefined)
            url_ += "totalNumber=" + encodeURIComponent("" + totalNumber) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 查询批次集合
     * @param filter (optional) 过滤字段
     * @return OK
     */
    list(filter: string | null | undefined): Promise<SimpleProductBatchVo[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-console')+ "/product-registers/list?";
        if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<SimpleProductBatchVo[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SimpleProductBatchVo.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<SimpleProductBatchVo[]>(<any>null);
    }

    /**
     * 分页查询批次
     * @param current (optional) 当前页
     * @param filter (optional) 过滤字段
     * @param size (optional) 每页的数量
     * @param tenantId (optional) 租户名称
     * @return OK
     */
    page(current: number | null | undefined, filter: string | null | undefined, size: number | null | undefined, tenantId: string | null | undefined): Promise<PageOfProductBatchVo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-console')+ "/product-registers/page?";
        if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPage(_response);
        });
    }

    protected processPage(response: AxiosResponse): Promise<PageOfProductBatchVo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PageOfProductBatchVo.fromJS(resultData200) : new PageOfProductBatchVo();
            return result200;
        }
        return Promise.resolve<PageOfProductBatchVo>(<any>null);
    }

    /**
     * 删除批次
     * @param batchNo 批次号
     * @return OK
     */
    delete(batchNo: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-console')+ "/product-registers/{batchNo}";
        if (batchNo === undefined || batchNo === null)
            throw new Error("The parameter 'batchNo' must be defined.");
        url_ = url_.replace("{batchNo}", encodeURIComponent("" + batchNo)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class AuthorInfoVo implements IAuthorInfoVo {
    /** 授权应用数量 */
    allowConnections!: string | undefined;
    /** 边缘设备描述 */
    description!: string | undefined;
    /** 边缘设备SN */
    gatewaySN!: string | undefined;
    /** 边缘设备Token */
    gatewayToken!: string | undefined;
    /** IotHub服务地址 */
    iotHubServer!: string | undefined;
    /** 授权应用数量 */
    productType!: string | undefined;

    constructor(data?: IAuthorInfoVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.allowConnections = data["allowConnections"];
            this.description = data["description"];
            this.gatewaySN = data["gatewaySN"];
            this.gatewayToken = data["gatewayToken"];
            this.iotHubServer = data["iotHubServer"];
            this.productType = data["productType"];
        }
    }

    static fromJS(data: any): AuthorInfoVo {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorInfoVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowConnections"] = this.allowConnections;
        data["description"] = this.description;
        data["gatewaySN"] = this.gatewaySN;
        data["gatewayToken"] = this.gatewayToken;
        data["iotHubServer"] = this.iotHubServer;
        data["productType"] = this.productType;
        return data; 
    }
}

export interface IAuthorInfoVo {
    /** 授权应用数量 */
    allowConnections: string | undefined;
    /** 边缘设备描述 */
    description: string | undefined;
    /** 边缘设备SN */
    gatewaySN: string | undefined;
    /** 边缘设备Token */
    gatewayToken: string | undefined;
    /** IotHub服务地址 */
    iotHubServer: string | undefined;
    /** 授权应用数量 */
    productType: string | undefined;
}

export class AuthorizationVo implements IAuthorizationVo {
    /** AES密文字符串 */
    aesFile!: string | undefined;
    /** 描述[别名] */
    alias!: string | undefined;
    /** 授权应用数 */
    allowConnections!: number | undefined;
    /** 创建人 */
    createName!: string | undefined;
    /** 激活时间 */
    createTime!: Date | undefined;
    /** 首次上线时间 */
    firstOnlineTime!: Date | undefined;
    /** 边缘设备主键 */
    id!: string | undefined;
    /** 最后上线时间 */
    lastOnlineTime!: Date | undefined;
    /** SAAS平台解析密文接口地址 */
    parseAesAddress!: string | undefined;
    /** 实时位置 */
    position!: string | undefined;
    /** 产品代码 */
    productCode!: string | undefined;
    /** 产品名称 */
    productName!: string | undefined;
    /** 边缘设备SN */
    sn!: string | undefined;
    /** 状态[在线|离线] */
    status!: string | undefined;
    /** 产品类型[3:软件边缘设备|1:硬件边缘设备] */
    type!: string | undefined;
    /** 已用应用数 */
    usedConnections!: number | undefined;
    /** 固件版本 */
    version!: string | undefined;

    constructor(data?: IAuthorizationVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.aesFile = data["aesFile"];
            this.alias = data["alias"];
            this.allowConnections = data["allowConnections"];
            this.createName = data["createName"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.firstOnlineTime = data["firstOnlineTime"] ? new Date(data["firstOnlineTime"].toString()) : <any>undefined;
            this.id = data["id"];
            this.lastOnlineTime = data["lastOnlineTime"] ? new Date(data["lastOnlineTime"].toString()) : <any>undefined;
            this.parseAesAddress = data["parseAesAddress"];
            this.position = data["position"];
            this.productCode = data["productCode"];
            this.productName = data["productName"];
            this.sn = data["sn"];
            this.status = data["status"];
            this.type = data["type"];
            this.usedConnections = data["usedConnections"];
            this.version = data["version"];
        }
    }

    static fromJS(data: any): AuthorizationVo {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizationVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aesFile"] = this.aesFile;
        data["alias"] = this.alias;
        data["allowConnections"] = this.allowConnections;
        data["createName"] = this.createName;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["firstOnlineTime"] = this.firstOnlineTime ? this.firstOnlineTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["lastOnlineTime"] = this.lastOnlineTime ? this.lastOnlineTime.toISOString() : <any>undefined;
        data["parseAesAddress"] = this.parseAesAddress;
        data["position"] = this.position;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["sn"] = this.sn;
        data["status"] = this.status;
        data["type"] = this.type;
        data["usedConnections"] = this.usedConnections;
        data["version"] = this.version;
        return data; 
    }
}

export interface IAuthorizationVo {
    /** AES密文字符串 */
    aesFile: string | undefined;
    /** 描述[别名] */
    alias: string | undefined;
    /** 授权应用数 */
    allowConnections: number | undefined;
    /** 创建人 */
    createName: string | undefined;
    /** 激活时间 */
    createTime: Date | undefined;
    /** 首次上线时间 */
    firstOnlineTime: Date | undefined;
    /** 边缘设备主键 */
    id: string | undefined;
    /** 最后上线时间 */
    lastOnlineTime: Date | undefined;
    /** SAAS平台解析密文接口地址 */
    parseAesAddress: string | undefined;
    /** 实时位置 */
    position: string | undefined;
    /** 产品代码 */
    productCode: string | undefined;
    /** 产品名称 */
    productName: string | undefined;
    /** 边缘设备SN */
    sn: string | undefined;
    /** 状态[在线|离线] */
    status: string | undefined;
    /** 产品类型[3:软件边缘设备|1:硬件边缘设备] */
    type: string | undefined;
    /** 已用应用数 */
    usedConnections: number | undefined;
    /** 固件版本 */
    version: string | undefined;
}

export class FileInfoDto implements IFileInfoDto {
    /** 文件id */
    fileId!: string | undefined;
    /** 文件名称 */
    fileName!: string | undefined;
    /** md5签名 */
    md5Code!: string | undefined;
    /** 文件大小 */
    size!: string | undefined;
    /** 文件后缀 */
    suffix!: string | undefined;
    /** 租户ID,多个使用 */
    tenantIds!: string[] | undefined;
    /** 版本 */
    version!: string | undefined;

    constructor(data?: IFileInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileId = data["fileId"];
            this.fileName = data["fileName"];
            this.md5Code = data["md5Code"];
            this.size = data["size"];
            this.suffix = data["suffix"];
            if (data["tenantIds"] && data["tenantIds"].constructor === Array) {
                this.tenantIds = [] as any;
                for (let item of data["tenantIds"])
                    this.tenantIds!.push(item);
            }
            this.version = data["version"];
        }
    }

    static fromJS(data: any): FileInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["fileName"] = this.fileName;
        data["md5Code"] = this.md5Code;
        data["size"] = this.size;
        data["suffix"] = this.suffix;
        if (this.tenantIds && this.tenantIds.constructor === Array) {
            data["tenantIds"] = [];
            for (let item of this.tenantIds)
                data["tenantIds"].push(item);
        }
        data["version"] = this.version;
        return data; 
    }
}

export interface IFileInfoDto {
    /** 文件id */
    fileId: string | undefined;
    /** 文件名称 */
    fileName: string | undefined;
    /** md5签名 */
    md5Code: string | undefined;
    /** 文件大小 */
    size: string | undefined;
    /** 文件后缀 */
    suffix: string | undefined;
    /** 租户ID,多个使用 */
    tenantIds: string[] | undefined;
    /** 版本 */
    version: string | undefined;
}

export class GatewayVo implements IGatewayVo {
    /** 允许连接数 */
    allowConnectionCount!: number | undefined;
    /** 批次 */
    batchNo!: string | undefined;
    /** 运营商CALL */
    cellInfo!: string | undefined;
    /** 城市CODE */
    cityAdcode!: string | undefined;
    /** 城市名字 */
    cityName!: string | undefined;
    /** 创建时间 */
    createTime!: Date | undefined;
    /** 创建人 */
    createUser!: string | undefined;
    /** 创建人名称 */
    createUserName!: string | undefined;
    firmwareVersion!: string | undefined;
    /** 第一次上线时间 */
    firstOnlineTime!: Date | undefined;
    firstPos!: string | undefined;
    flow!: number | undefined;
    /** 运营商ＩＣＣＩＤ */
    iccid!: string | undefined;
    /** 主键 */
    id!: string | undefined;
    /** IP */
    ip!: string | undefined;
    /** 是否删除 */
    isDeleted!: boolean | undefined;
    /** 是否在线 */
    isOnline!: boolean | undefined;
    /** 最后在线时间 */
    lastOnlineTime!: Date | undefined;
    /** 锁状态 */
    lockStatus!: number | undefined;
    /** 名称 */
    name!: string | undefined;
    /** 位置 */
    position!: string | undefined;
    /** 产品类型 */
    productType!: number | undefined;
    /** SN编号 */
    sn!: string | undefined;
    /** token */
    token!: string | undefined;
    total!: string | undefined;
    traffic!: string | undefined;
    /** 修改时间 */
    updateTime!: Date | undefined;
    /** 修改人 */
    updateUser!: string | undefined;
    /** 已经创建连接 */
    usedConnectionCount!: number | undefined;
    /** 版本 */
    version!: string | undefined;

    constructor(data?: IGatewayVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.allowConnectionCount = data["allowConnectionCount"];
            this.batchNo = data["batchNo"];
            this.cellInfo = data["cellInfo"];
            this.cityAdcode = data["cityAdcode"];
            this.cityName = data["cityName"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.createUser = data["createUser"];
            this.createUserName = data["createUserName"];
            this.firmwareVersion = data["firmwareVersion"];
            this.firstOnlineTime = data["firstOnlineTime"] ? new Date(data["firstOnlineTime"].toString()) : <any>undefined;
            this.firstPos = data["firstPos"];
            this.flow = data["flow"];
            this.iccid = data["iccid"];
            this.id = data["id"];
            this.ip = data["ip"];
            this.isDeleted = data["isDeleted"];
            this.isOnline = data["isOnline"];
            this.lastOnlineTime = data["lastOnlineTime"] ? new Date(data["lastOnlineTime"].toString()) : <any>undefined;
            this.lockStatus = data["lockStatus"];
            this.name = data["name"];
            this.position = data["position"];
            this.productType = data["productType"];
            this.sn = data["sn"];
            this.token = data["token"];
            this.total = data["total"];
            this.traffic = data["traffic"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
            this.updateUser = data["updateUser"];
            this.usedConnectionCount = data["usedConnectionCount"];
            this.version = data["version"];
        }
    }

    static fromJS(data: any): GatewayVo {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowConnectionCount"] = this.allowConnectionCount;
        data["batchNo"] = this.batchNo;
        data["cellInfo"] = this.cellInfo;
        data["cityAdcode"] = this.cityAdcode;
        data["cityName"] = this.cityName;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["createUser"] = this.createUser;
        data["createUserName"] = this.createUserName;
        data["firmwareVersion"] = this.firmwareVersion;
        data["firstOnlineTime"] = this.firstOnlineTime ? this.firstOnlineTime.toISOString() : <any>undefined;
        data["firstPos"] = this.firstPos;
        data["flow"] = this.flow;
        data["iccid"] = this.iccid;
        data["id"] = this.id;
        data["ip"] = this.ip;
        data["isDeleted"] = this.isDeleted;
        data["isOnline"] = this.isOnline;
        data["lastOnlineTime"] = this.lastOnlineTime ? this.lastOnlineTime.toISOString() : <any>undefined;
        data["lockStatus"] = this.lockStatus;
        data["name"] = this.name;
        data["position"] = this.position;
        data["productType"] = this.productType;
        data["sn"] = this.sn;
        data["token"] = this.token;
        data["total"] = this.total;
        data["traffic"] = this.traffic;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["updateUser"] = this.updateUser;
        data["usedConnectionCount"] = this.usedConnectionCount;
        data["version"] = this.version;
        return data; 
    }
}

export interface IGatewayVo {
    /** 允许连接数 */
    allowConnectionCount: number | undefined;
    /** 批次 */
    batchNo: string | undefined;
    /** 运营商CALL */
    cellInfo: string | undefined;
    /** 城市CODE */
    cityAdcode: string | undefined;
    /** 城市名字 */
    cityName: string | undefined;
    /** 创建时间 */
    createTime: Date | undefined;
    /** 创建人 */
    createUser: string | undefined;
    /** 创建人名称 */
    createUserName: string | undefined;
    firmwareVersion: string | undefined;
    /** 第一次上线时间 */
    firstOnlineTime: Date | undefined;
    firstPos: string | undefined;
    flow: number | undefined;
    /** 运营商ＩＣＣＩＤ */
    iccid: string | undefined;
    /** 主键 */
    id: string | undefined;
    /** IP */
    ip: string | undefined;
    /** 是否删除 */
    isDeleted: boolean | undefined;
    /** 是否在线 */
    isOnline: boolean | undefined;
    /** 最后在线时间 */
    lastOnlineTime: Date | undefined;
    /** 锁状态 */
    lockStatus: number | undefined;
    /** 名称 */
    name: string | undefined;
    /** 位置 */
    position: string | undefined;
    /** 产品类型 */
    productType: number | undefined;
    /** SN编号 */
    sn: string | undefined;
    /** token */
    token: string | undefined;
    total: string | undefined;
    traffic: string | undefined;
    /** 修改时间 */
    updateTime: Date | undefined;
    /** 修改人 */
    updateUser: string | undefined;
    /** 已经创建连接 */
    usedConnectionCount: number | undefined;
    /** 版本 */
    version: string | undefined;
}

export class IothubVo implements IIothubVo {
    /** 网关端口 */
    gatewayPort!: string | undefined;
    /** 域名 */
    host!: string | undefined;
    /** 主键 */
    id!: string | undefined;
    /** 端口 */
    port!: number | undefined;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: IIothubVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gatewayPort = data["gatewayPort"];
            this.host = data["host"];
            this.id = data["id"];
            this.port = data["port"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): IothubVo {
        data = typeof data === 'object' ? data : {};
        let result = new IothubVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gatewayPort"] = this.gatewayPort;
        data["host"] = this.host;
        data["id"] = this.id;
        data["port"] = this.port;
        data["remark"] = this.remark;
        return data; 
    }
}

export interface IIothubVo {
    /** 网关端口 */
    gatewayPort: string | undefined;
    /** 域名 */
    host: string | undefined;
    /** 主键 */
    id: string | undefined;
    /** 端口 */
    port: number | undefined;
    /** 备注 */
    remark: string | undefined;
}

export class IssueFirmwareDto implements IIssueFirmwareDto {
    /** 固件ID */
    firmwareId!: string | undefined;
    /** 网关Code集合 */
    gatewayCode!: string[] | undefined;

    constructor(data?: IIssueFirmwareDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.firmwareId = data["firmwareId"];
            if (data["gatewayCode"] && data["gatewayCode"].constructor === Array) {
                this.gatewayCode = [] as any;
                for (let item of data["gatewayCode"])
                    this.gatewayCode!.push(item);
            }
        }
    }

    static fromJS(data: any): IssueFirmwareDto {
        data = typeof data === 'object' ? data : {};
        let result = new IssueFirmwareDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firmwareId"] = this.firmwareId;
        if (this.gatewayCode && this.gatewayCode.constructor === Array) {
            data["gatewayCode"] = [];
            for (let item of this.gatewayCode)
                data["gatewayCode"].push(item);
        }
        return data; 
    }
}

export interface IIssueFirmwareDto {
    /** 固件ID */
    firmwareId: string | undefined;
    /** 网关Code集合 */
    gatewayCode: string[] | undefined;
}

export class OrderItem implements IOrderItem {
    asc!: boolean | undefined;
    column!: string | undefined;

    constructor(data?: IOrderItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.asc = data["asc"];
            this.column = data["column"];
        }
    }

    static fromJS(data: any): OrderItem {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["asc"] = this.asc;
        data["column"] = this.column;
        return data; 
    }
}

export interface IOrderItem {
    asc: boolean | undefined;
    column: string | undefined;
}

export class PageOfGatewayVo implements IPageOfGatewayVo {
    countId!: string | undefined;
    current!: string | undefined;
    hitCount!: boolean | undefined;
    maxLimit!: string | undefined;
    optimizeCountSql!: boolean | undefined;
    orders!: OrderItem[] | undefined;
    pages!: string | undefined;
    records!: GatewayVo[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IPageOfGatewayVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.countId = data["countId"];
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.maxLimit = data["maxLimit"];
            this.optimizeCountSql = data["optimizeCountSql"];
            if (data["orders"] && data["orders"].constructor === Array) {
                this.orders = [] as any;
                for (let item of data["orders"])
                    this.orders!.push(OrderItem.fromJS(item));
            }
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(GatewayVo.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): PageOfGatewayVo {
        data = typeof data === 'object' ? data : {};
        let result = new PageOfGatewayVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countId"] = this.countId;
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["maxLimit"] = this.maxLimit;
        data["optimizeCountSql"] = this.optimizeCountSql;
        if (this.orders && this.orders.constructor === Array) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IPageOfGatewayVo {
    countId: string | undefined;
    current: string | undefined;
    hitCount: boolean | undefined;
    maxLimit: string | undefined;
    optimizeCountSql: boolean | undefined;
    orders: OrderItem[] | undefined;
    pages: string | undefined;
    records: GatewayVo[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class PageOfProductBatchVo implements IPageOfProductBatchVo {
    countId!: string | undefined;
    current!: string | undefined;
    hitCount!: boolean | undefined;
    maxLimit!: string | undefined;
    optimizeCountSql!: boolean | undefined;
    orders!: OrderItem[] | undefined;
    pages!: string | undefined;
    records!: ProductBatchVo[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IPageOfProductBatchVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.countId = data["countId"];
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.maxLimit = data["maxLimit"];
            this.optimizeCountSql = data["optimizeCountSql"];
            if (data["orders"] && data["orders"].constructor === Array) {
                this.orders = [] as any;
                for (let item of data["orders"])
                    this.orders!.push(OrderItem.fromJS(item));
            }
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(ProductBatchVo.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): PageOfProductBatchVo {
        data = typeof data === 'object' ? data : {};
        let result = new PageOfProductBatchVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countId"] = this.countId;
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["maxLimit"] = this.maxLimit;
        data["optimizeCountSql"] = this.optimizeCountSql;
        if (this.orders && this.orders.constructor === Array) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IPageOfProductBatchVo {
    countId: string | undefined;
    current: string | undefined;
    hitCount: boolean | undefined;
    maxLimit: string | undefined;
    optimizeCountSql: boolean | undefined;
    orders: OrderItem[] | undefined;
    pages: string | undefined;
    records: ProductBatchVo[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class PagingOf固件信息 implements IPagingOf固件信息 {
    current!: string | undefined;
    items!: 固件信息[] | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IPagingOf固件信息) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(固件信息.fromJS(item));
            }
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): PagingOf固件信息 {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOf固件信息();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IPagingOf固件信息 {
    current: string | undefined;
    items: 固件信息[] | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class PagingOf固件日志信息 implements IPagingOf固件日志信息 {
    current!: string | undefined;
    items!: 固件日志信息[] | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IPagingOf固件日志信息) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(固件日志信息.fromJS(item));
            }
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): PagingOf固件日志信息 {
        data = typeof data === 'object' ? data : {};
        let result = new PagingOf固件日志信息();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IPagingOf固件日志信息 {
    current: string | undefined;
    items: 固件日志信息[] | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class ProductBatchVo implements IProductBatchVo {
    /** 激活码 */
    activateKey!: string | undefined;
    /** 允许连接数 */
    allowConnectionCount!: number | undefined;
    /** 批次号 */
    batchNo!: string | undefined;
    /** 创建时间 */
    createTime!: Date | undefined;
    /** 创建人 */
    createUser!: string | undefined;
    /** 创建人名称 */
    createUserName!: string | undefined;
    /** 主键 */
    id!: string | undefined;
    /** iothub 网关端口 */
    iothubGatewayPort!: string | undefined;
    /** iothub host */
    iothubHost!: string | undefined;
    /** IOTHUB id */
    iothubId!: string | undefined;
    /** iothub 端口 */
    iothubPort!: number | undefined;
    /** 已发货数 */
    onlineCount!: number | undefined;
    /** 产品编号 */
    productCode!: string | undefined;
    /** 产品名称 */
    productName!: string | undefined;
    /** 产品类型 */
    productType!: number | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 租户 */
    tenantId!: string | undefined;
    /** 租户 */
    tenantName!: string | undefined;
    /** 生产总量 */
    totalNumber!: number | undefined;
    /** 修改时间 */
    updateTime!: Date | undefined;
    /** 修改人 */
    updateUser!: string | undefined;

    constructor(data?: IProductBatchVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.activateKey = data["activateKey"];
            this.allowConnectionCount = data["allowConnectionCount"];
            this.batchNo = data["batchNo"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.createUser = data["createUser"];
            this.createUserName = data["createUserName"];
            this.id = data["id"];
            this.iothubGatewayPort = data["iothubGatewayPort"];
            this.iothubHost = data["iothubHost"];
            this.iothubId = data["iothubId"];
            this.iothubPort = data["iothubPort"];
            this.onlineCount = data["onlineCount"];
            this.productCode = data["productCode"];
            this.productName = data["productName"];
            this.productType = data["productType"];
            this.remark = data["remark"];
            this.tenantId = data["tenantId"];
            this.tenantName = data["tenantName"];
            this.totalNumber = data["totalNumber"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
            this.updateUser = data["updateUser"];
        }
    }

    static fromJS(data: any): ProductBatchVo {
        data = typeof data === 'object' ? data : {};
        let result = new ProductBatchVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activateKey"] = this.activateKey;
        data["allowConnectionCount"] = this.allowConnectionCount;
        data["batchNo"] = this.batchNo;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["createUser"] = this.createUser;
        data["createUserName"] = this.createUserName;
        data["id"] = this.id;
        data["iothubGatewayPort"] = this.iothubGatewayPort;
        data["iothubHost"] = this.iothubHost;
        data["iothubId"] = this.iothubId;
        data["iothubPort"] = this.iothubPort;
        data["onlineCount"] = this.onlineCount;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["productType"] = this.productType;
        data["remark"] = this.remark;
        data["tenantId"] = this.tenantId;
        data["tenantName"] = this.tenantName;
        data["totalNumber"] = this.totalNumber;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["updateUser"] = this.updateUser;
        return data; 
    }
}

export interface IProductBatchVo {
    /** 激活码 */
    activateKey: string | undefined;
    /** 允许连接数 */
    allowConnectionCount: number | undefined;
    /** 批次号 */
    batchNo: string | undefined;
    /** 创建时间 */
    createTime: Date | undefined;
    /** 创建人 */
    createUser: string | undefined;
    /** 创建人名称 */
    createUserName: string | undefined;
    /** 主键 */
    id: string | undefined;
    /** iothub 网关端口 */
    iothubGatewayPort: string | undefined;
    /** iothub host */
    iothubHost: string | undefined;
    /** IOTHUB id */
    iothubId: string | undefined;
    /** iothub 端口 */
    iothubPort: number | undefined;
    /** 已发货数 */
    onlineCount: number | undefined;
    /** 产品编号 */
    productCode: string | undefined;
    /** 产品名称 */
    productName: string | undefined;
    /** 产品类型 */
    productType: number | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 租户 */
    tenantId: string | undefined;
    /** 租户 */
    tenantName: string | undefined;
    /** 生产总量 */
    totalNumber: number | undefined;
    /** 修改时间 */
    updateTime: Date | undefined;
    /** 修改人 */
    updateUser: string | undefined;
}

/** 查询条件 */
export class Query implements IQuery {
    /** 当前页 */
    current!: number | undefined;
    /** 每页的数量 */
    size!: number | undefined;

    constructor(data?: IQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.size = data["size"];
        }
    }

    static fromJS(data: any): Query {
        data = typeof data === 'object' ? data : {};
        let result = new Query();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["size"] = this.size;
        return data; 
    }
}

/** 查询条件 */
export interface IQuery {
    /** 当前页 */
    current: number | undefined;
    /** 每页的数量 */
    size: number | undefined;
}

export class QueryFirmwareLogDto implements IQueryFirmwareLogDto {
    /** 固件名称 */
    firmwareName!: string | undefined;
    /** 边缘设备Code */
    gatewayCode!: string | undefined;
    /** 分页参数 */
    query!: Query | undefined;
    /** 租户ID */
    tenantId!: string | undefined;

    constructor(data?: IQueryFirmwareLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.firmwareName = data["firmwareName"];
            this.gatewayCode = data["gatewayCode"];
            this.query = data["query"] ? Query.fromJS(data["query"]) : <any>undefined;
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): QueryFirmwareLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new QueryFirmwareLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firmwareName"] = this.firmwareName;
        data["gatewayCode"] = this.gatewayCode;
        data["query"] = this.query ? this.query.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IQueryFirmwareLogDto {
    /** 固件名称 */
    firmwareName: string | undefined;
    /** 边缘设备Code */
    gatewayCode: string | undefined;
    /** 分页参数 */
    query: Query | undefined;
    /** 租户ID */
    tenantId: string | undefined;
}

export class SimpleProductBatchVo implements ISimpleProductBatchVo {
    /** 批次号 */
    batchNo!: string | undefined;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: ISimpleProductBatchVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.batchNo = data["batchNo"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): SimpleProductBatchVo {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleProductBatchVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchNo"] = this.batchNo;
        data["remark"] = this.remark;
        return data; 
    }
}

export interface ISimpleProductBatchVo {
    /** 批次号 */
    batchNo: string | undefined;
    /** 备注 */
    remark: string | undefined;
}

export class 固件信息 implements I固件信息 {
    /** 上传时间 */
    createTime!: Date | undefined;
    /** 文件ID */
    fileId!: string | undefined;
    /** 文件名称 */
    fileName!: string | undefined;
    /** ID */
    id!: string | undefined;
    /** 大小[字节] */
    size!: string | undefined;
    /** 租户ID */
    tenantId!: string | undefined;
    /** 版本 */
    version!: string | undefined;

    constructor(data?: I固件信息) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.fileId = data["fileId"];
            this.fileName = data["fileName"];
            this.id = data["id"];
            this.size = data["size"];
            this.tenantId = data["tenantId"];
            this.version = data["version"];
        }
    }

    static fromJS(data: any): 固件信息 {
        data = typeof data === 'object' ? data : {};
        let result = new 固件信息();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["fileId"] = this.fileId;
        data["fileName"] = this.fileName;
        data["id"] = this.id;
        data["size"] = this.size;
        data["tenantId"] = this.tenantId;
        data["version"] = this.version;
        return data; 
    }
}

export interface I固件信息 {
    /** 上传时间 */
    createTime: Date | undefined;
    /** 文件ID */
    fileId: string | undefined;
    /** 文件名称 */
    fileName: string | undefined;
    /** ID */
    id: string | undefined;
    /** 大小[字节] */
    size: string | undefined;
    /** 租户ID */
    tenantId: string | undefined;
    /** 版本 */
    version: string | undefined;
}

export class 固件日志信息 implements I固件日志信息 {
    /** 动作 */
    action!: string | undefined;
    /** 发生时间 */
    createTime!: Date | undefined;
    /** 文件名称 */
    fileName!: string | undefined;
    /** 网关SN */
    gatewayCode!: string | undefined;
    /** 批次号 */
    issueId!: string | undefined;
    /** 结果 */
    state!: number | undefined;
    /** 租户ID */
    tenantId!: string | undefined;

    constructor(data?: I固件日志信息) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.action = data["action"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.fileName = data["fileName"];
            this.gatewayCode = data["gatewayCode"];
            this.issueId = data["issueId"];
            this.state = data["state"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): 固件日志信息 {
        data = typeof data === 'object' ? data : {};
        let result = new 固件日志信息();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["fileName"] = this.fileName;
        data["gatewayCode"] = this.gatewayCode;
        data["issueId"] = this.issueId;
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface I固件日志信息 {
    /** 动作 */
    action: string | undefined;
    /** 发生时间 */
    createTime: Date | undefined;
    /** 文件名称 */
    fileName: string | undefined;
    /** 网关SN */
    gatewayCode: string | undefined;
    /** 批次号 */
    issueId: string | undefined;
    /** 结果 */
    state: number | undefined;
    /** 租户ID */
    tenantId: string | undefined;
}

export class 固件日志信息_1 implements I固件日志信息_1 {
    /** 动作 */
    action!: number | undefined;
    /** 发生时间 */
    createTime!: Date | undefined;
    /** 批次号 */
    issueId!: string | undefined;
    /** 结果 */
    state!: number | undefined;

    constructor(data?: I固件日志信息_1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.action = data["action"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.issueId = data["issueId"];
            this.state = data["state"];
        }
    }

    static fromJS(data: any): 固件日志信息_1 {
        data = typeof data === 'object' ? data : {};
        let result = new 固件日志信息_1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["issueId"] = this.issueId;
        data["state"] = this.state;
        return data; 
    }
}

export interface I固件日志信息_1 {
    /** 动作 */
    action: number | undefined;
    /** 发生时间 */
    createTime: Date | undefined;
    /** 批次号 */
    issueId: string | undefined;
    /** 结果 */
    state: number | undefined;
}